// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label[data-v-8009cdb4]{font-size:14px!important;font-weight:500!important;color:#141c20!important;text-transform:none!important}.description *[data-v-8009cdb4]{font-size:14px;font-weight:400;color:#7c8b91}.description .sb-icon[data-v-8009cdb4]{padding-bottom:2px}", ""]);
// Exports
module.exports = exports;
